import DOMPurify from 'dompurify';

export const sanitizeRichText = (html) => {
    if (!html) return html;
    const decoded = decodeHTMLEntities(html);
    const clean = DOMPurify.sanitize(decoded, { ADD_ATTR: ['target', 'rel'] });
    const div = document.createElement('div');
    div.innerHTML = clean;
    div.querySelectorAll('a[href]').forEach(a => {
        const href = a.getAttribute('href');
        if (href && !/^[a-z][a-z\d+\-.]*:/i.test(href) && !href.startsWith('/') && !href.startsWith('#')) {
            a.setAttribute('href', 'https://' + href);
        }
        a.setAttribute('target', '_blank');
        a.setAttribute('rel', 'noopener noreferrer');
    });
    return div.innerHTML;
};

export const decodeHTMLEntities = (text) => {
    if (!text) return text;
    const textArea = document.createElement('textarea');
    textArea.innerHTML = text;
    return textArea.value;
};

export const getCleanDescription = (html, maxLength = 160) => {
    if (!html) return '';
    const tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    const text = tmp.textContent || tmp.innerText || "";
    const cleanText = text.replace(/\s+/g, ' ').trim();
    if (cleanText.length <= maxLength) return cleanText;
    return cleanText.substring(0, maxLength) + "...";
};
